
































































































































import {Component, Prop} from "vue-property-decorator";
import WarehouseTable from "@/modules/warehouses/shared/components/WarehouseTable/index.vue";
import {mixins} from "vue-class-component";
import {CommonMixin} from "@/shared/services/mixin";
import {PickingListTranshipmentStore} from "@/modules/pickinglisttranshipment";
import {Lading} from "@/interfaces/entity";
import LadingStatusLabel from "@/shared/components/LadingStatusLabel/index.vue";

@Component({
    name: "PLTranshipmentExcel",
    components: {LadingStatusLabel, WarehouseTable}
})
export default class extends mixins(CommonMixin) {
    @Prop({required: true, type: Number}) readonly id!: number;
    columns = [
        {
            title: "STT",
            dataIndex: "stt",
            key: "stt",
            width: 50
        },
        {
            title: "Mã vận đơn",
            dataIndex: "ladingCode",
            key: "ladingCode",
            width: 120
        },
        {
            title: "SĐT người nhận",
            dataIndex: "locationTo.phoneNumber",
            key: "locationToPhoneNumber",
            width: 120
        },
        {
            title: "Tên người nhận",
            dataIndex: "locationTo.name",
            key: "locationToName",
            width: 120
        },
        {
            title: "Địa chỉ nhận",
            dataIndex: "ladingRowGuid",
            key: "locationToAddress",
            scopedSlots: {customRender: "locationToAddress"},
            width: 300
        },
        {
            title: "TL",
            dataIndex: "weight",
            key: "ladingWeight",
            width: 50
        },
        {
            title: "SK",
            dataIndex: "boxQuantity",
            key: "ladingBoxQuantity",
            width: 50
        },
        {
            title: "Dịch vụ",
            dataIndex: "freightService.serviceCode",
            key: "ladingFreightService",
            width: 100
        },
        {
            title: "Thu tiền NN",
            dataIndex: "receiverCollect",
            key: "receiverCollect",
            width: 100
        },
        {
            title: "Trạng thái",
            dataIndex: "status",
            scopedSlots: {customRender: "status"},
            key: "status",
            width: 100
        }
    ];

    get billLadings() {
        const billLadings = this.getProp(this.pickingListTranshipment, 'billLadings', []) as any;
        return billLadings.map((billLading: Lading, index) => ({...billLading, stt: index + 1}));
    }

    get pickingListTranshipment() {
        return PickingListTranshipmentStore.data[this.id];
    }

    get receiverCollect() {
        const receiverCollect = this.getProp(this.pickingListTranshipment, 'receiverCollect');
        return receiverCollect
            ? receiverCollect.toLocaleString('en-US') + 'đ'
            : 0;
    }
}
